import { ReactNode } from "react";
import { NumberToCZKExtraDigits, NumberToFloat } from "../../helpers/NumberToCzFormatter";

/** Used by {@link ParseValue} in table cells to determine, how data should be displayed*/
export type EnumCellType = undefined | "percent" | "money";

/** Used for parsing given values according to their type */
export const ParseValue = (value: number | string | ReactNode | null, type: EnumCellType): ReactNode => {
    if (type === undefined && typeof value === "number") return NumberToFloat(value);
    if (type === undefined && typeof value === "string") return value;
    if (type === "percent" && typeof value === "number") return NumberToFloat(value) + " %";
    if (type === "money" && typeof value === "number") return NumberToCZKExtraDigits(value, 2);

    return value;
};

/** Serializes an object into an array of numbers/strings/ReactNode */
export const SerializeObjects = (arr: Record<string, string | number | ReactNode>[]) => {
    return arr.map((row) => Object.keys(row).map((key) => row[key]));
};

/** Extracts keys from key-value pairs and returns them as an array */
export const ExtractKeys = (arr: Record<string, any>) => {
    return Object.keys(arr);
};

/** Extracts values from arrays of key-value pairs and returns them as an array of arrays */
export const ExtractData = (arr: Record<string, string | number | ReactNode>[]) => {
    return arr.map((row) => Object.values(row));
};
